import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useLang, t } from "@/context/LangContext";
import { Menu } from "lucide-react";

const LOGO_URL = "/assets/logo.jpg";

const links = [
  { to: "/", label_id: "Beranda", label_en: "Home", testid: "nav-home" },
  { to: "/analysis", label_id: "Analisa", label_en: "Analysis", testid: "nav-analysis" },
  { to: "/ipo", label_id: "IPO", label_en: "IPO", testid: "nav-ipo" },
  { to: "/recommendations", label_id: "Rekomendasi", label_en: "Picks", testid: "nav-recs" },
  { to: "/calculators", label_id: "Kalkulator", label_en: "Calculators", testid: "nav-calc" },
  { to: "/education", label_id: "Edukasi", label_en: "Learn", testid: "nav-edu" },
  { to: "/ai-chat", label_id: "AI Analis", label_en: "AI Analyst", testid: "nav-ai" },
];

const Header = () => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = React.useState(false);

  return (
    <header className="sticky top-0 z-50 glass border-b border-white/10" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-3 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-link">
          <img
            src={LOGO_URL}
            alt="Pintar Investasi"
            className="w-10 h-10 rounded-md object-cover"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <div className="font-display font-black text-base tracking-tight">PINTAR</div>
            <div className="font-display font-light text-xs text-white/50 tracking-[0.15em] uppercase">Investasi</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.testid}
              className={({ isActive }) =>
                `px-4 py-2 text-sm rounded-full transition-colors ${
                  isActive ? "bg-white text-black font-medium" : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
            >
              {t(lang, l.label_id, l.label_en)}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center border border-white/15 rounded-full p-0.5" data-testid="lang-toggle">
            <button
              onClick={() => setLang("id")}
              className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${lang === "id" ? "bg-white text-black" : "text-white/60 hover:text-white"}`}
              data-testid="lang-id"
            >
              ID
            </button>
            <button
              onClick={() => setLang("en")}
              className={`px-3 py-1 text-xs font-medium rounded-full transition-colors ${lang === "en" ? "bg-white text-black" : "text-white/60 hover:text-white"}`}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
          <button
            className="lg:hidden p-2 border border-white/15 rounded-md"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-btn"
          >
            <Menu size={18} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 px-6 py-4 flex flex-col gap-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded ${isActive ? "bg-white text-black" : "text-white/70 hover:bg-white/5"}`
              }
            >
              {t(lang, l.label_id, l.label_en)}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
